import api from "./api";

export const getAllGammaLines = (gammaPath, language) => {
  return () => api.get(`/categories/gammalines/${gammaPath}?language=${language}`);
};

export const getAllLineFamilies = (gammaPath, linePath, language) => {
  return () =>
    api.get(
      `/categories/linefamilies/${gammaPath}/${linePath}?language=${language}`
    );
}

export const getFamily = (gammaPath, linePath, familyPath, language) => {
  return () =>
    api.get(
      `/categories/family/${gammaPath}/${linePath}/${familyPath}?language=${language}`
    );
}
